var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.empty)?_c('a-empty',{attrs:{"image":_vm.simpleImage}}):_vm._e(),_c('a-spin',{attrs:{"tip":"Loading...","spinning":_vm.spinning}}),_c('v-chart',{attrs:{"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }